module.exports = __webpack_public_path__ + "static/media/post.daeeebfd.png";